import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form, actions } from 'react-redux-form';
import { Grid, Row, Col, Button } from 'react-bootstrap';
import DeliveryAddress from './delivery-address';
import OrderSummary from './order-summary';
import OrderDetailsRow from './order-details-row';
import ThankYouPanel from '../thank-you/index';
import PageTitle from '../../common/page-title'
import SectionTitle from '../../common/section-title';
import InlineCKEditor from '../../common/editor/inline-editor';
import { isRrfFormValid } from '../../../utils/commonFunctions';
import { history } from '../../../store';
import { getOrderToConfirm, confirmOrder, newOrder, orderAgain } from '../../../actions/orders';
import { getMyProfile } from '../../../actions/user';
import { loadPageContent } from '../../../actions/content';
import ConfirmOrderButton from './confirm-order-button';
import OrderDeliveryDate from './order-delivery-date';
import ConfirmPopup from '../../common/confirm-popup';
import ForwardOrdersBanner from '../../../assets/img/forward-orders-banner-updated-V2.png';
import { saveEvent } from '../../../actions/events';

import './styles.css';

class OrderConfirmation extends Component {
  constructor(props) {
    super(props);

    this.pageSlug = 'order-confirmation';
    this.state = {
      showThankYou: false,
      isZoneModalOpen: false,
      isTobaccoModalOpen: false,
      isBluModalOpen: false,
    };
  }

  filterDataByCategory = (categoryName, data) => {
    return data.filter((lineItem) => {
      const { attributes: { product: { category: { name } } } } = lineItem;

      return name === categoryName;
    });
  }

  componentWillMount() {
    const { dispatch } = this.props;
    this.id = +this.props.match.params.id;

    dispatch(getOrderToConfirm(false, this.props.selectedOutletId)).then(() => {
      const { order: { relationships } } = this.props;
      const { data } = relationships['line-items'];
      const tobaccos = data.filter((lineItem) => {
        const { attributes: { product: { category: { name } } } } = lineItem;

        return !['Oral Tobacco', 'Vape'].includes(name);
      });
      const oralTobaccos = this.filterDataByCategory("Oral Tobacco", data);
      const vapes = this.filterDataByCategory("Vape", data);
      
      if (oralTobaccos.length === 0) {
        this.setState({ isZoneModalOpen: true });
      }

      if (vapes.length === 0) {
        this.setState({ isBluModalOpen: true });
      }

      if (tobaccos.length === 0) {
        this.setState({ isTobaccoModalOpen: true });
      }
    });
    dispatch(loadPageContent(`api/pages/${this.pageSlug}`));
  }

  toggleThankYou = () => {
    this.props.dispatch({ type: 'TOGGLE_THANK_YOU' });
  };

  handleOrderAgain = () => {
    this.props.dispatch(orderAgain(this.props.confirmation.id))
      .then(() => {
        this.props.dispatch(getMyProfile('CURRENT_USER_PROFILE'));
        this.toggleThankYou();
        history.push('/order/new');
      });
  };

  handleNewOrder = () => {
    this.toggleThankYou();
    this.props.dispatch(newOrder())
      .then(() => this.props.dispatch(getMyProfile('CURRENT_USER_PROFILE')));

    history.push('/order/new')
  };

  handleDone = () => {
    this.toggleThankYou();
    this.props.dispatch(newOrder())
      .then(() => this.props.dispatch(getMyProfile('CURRENT_USER_PROFILE')));
    history.push('/')
  };

  onSubmit = (payLoad) => {
    this.props.dispatch(actions.submit('deep.order.confirm', confirmOrder(payLoad)));
  };

  handleContentSaved = () => {
    this.props.dispatch(loadPageContent(`api/pages/${this.pageSlug}`));
  };

  toggleSaveOrderDialog = () => {
    this.props.dispatch({ type: 'TOGGLE_SAVE_ORDER_DIALOG' });
  };

  handleZoneModalClose = (isConfirm) => {
    const { dispatch } = this.props;

    this.setState({ isZoneModalOpen: false }, () => {
      if (isConfirm) {
        dispatch(saveEvent({ event: "Zone pop-up button being pressed" }));
        history.push('/order/new#zone');
      }
    });
  };

  handleBluModalClose = (isConfirm) => {
    this.setState({ isBluModalOpen: false}, () => {
      if (isConfirm) {
        history.push('/order/new#blu');
      }
    });
  };

  handleTobaccoModalClose = (isConfirm) => {
    this.setState({ isTobaccoModalOpen: false }, () => {
      if (isConfirm) {
        history.push('/order/new#tobacco');
      }
    });
  };

  render() {
    const { deliveryDate, orderLimit, orderLimitStartDate, orderLimitEndDate, orderedSoFar,
      orderLimitCategories, reduceQtyBy, orderLimitCategoryIds, features } = this.props;
    const { isZoneModalOpen, isBluModalOpen, isTobaccoModalOpen } = this.state;

    return (
      <Grid bsClass="container" className="order-confirmation wrapper">
        {features.delivery_date && <Row>
          <Col lg={12}>
            <div className="banner-container">
              <img className="banner-image" src={ForwardOrdersBanner} />
            </div>
          </Col>
        </Row>}
        {(this.props.new.basket.replacements.length > 0) && (<Row className="red-highlight">
            <Col lg={12}>
              DUE TO SOME PRODUCTS BEING OUT OF STOCK, REPLACEMENT PRODUCTS HAVE BEEN ADDED TO YOUR BASKET,
              THE QUANTITY OF WHICH IS BASED ON YOUR PREVIOUS ORDER HISTORY. PLEASE REVIEW THESE BEFORE CHECKOUT
            </Col>
          </Row>
        )}
        {(!!orderLimit) && (<Row className="red-highlight">
            <Col lg={12}>
              This store has an order limit of {orderLimit} products. You have ordered {orderedSoFar} products so far. The order limit
              period runs from {orderLimitStartDate} to {orderLimitEndDate}. This order limit includes products in the following categories: {orderLimitCategories}.
            </Col>
          </Row>
        )}
        {((orderedSoFar < orderLimit) && (reduceQtyBy > 0)) && (<Row className="red-highlight">
            <Col lg={12}>
              Unfortunately you have exceeded your maximum order limit for this period. Please reduce the quantity you
              are ordering by {reduceQtyBy} outers on any products highlighted below.
            </Col>
          </Row>
        )}
        {(orderedSoFar >= orderLimit) && (<Row className="red-highlight">
            <Col lg={12}>
              Unfortunately you have exceed your maximum order limit for this period. Your limit will reset on {orderLimitEndDate} and you will be able to place a new order then. Click here to
              <Button
                bsStyle="link"
                className="save-for-later"
                onClick={this.toggleSaveOrderDialog}>
                save
              </Button>
              this order for later, or remove the products highlighted below to place the
              order for products not included in the order limit.
            </Col>
          </Row>
        )}
        <Row>
          <Col lg={12}>
            <InlineCKEditor identifier={`${this.pageSlug}_content_text`}
                            onContentSaved={this.handleContentSaved}
                            contents={this.props.contents[`${this.pageSlug}_content_text`]} />
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <div className="header">
              <PageTitle className="pull-left">Confirm My Order</PageTitle>
            </div>
          </Col>
        </Row>
        <Form model="deep.order.confirm" onSubmit={this.onSubmit}>
          <Row>
            <Col lg={8}>
              <Row>
                <Col lg={12} className="address-box">
                <div>
                    <DeliveryAddress
                      outlets={this.props.outlets}
                      deliveryAddress={this.props.deliveryAddress}
                      features={this.props.features}
                    />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col lg={12}>
                  <div className="order-details">
                    <SectionTitle>Order details</SectionTitle>
                    {
                      this.props.order.relationships && !this.props.order.relationships['line-items'].data.length &&
                      <div className="ta-center">
                        <h3>Your basket is empty. Please add some items to checkout</h3>
                      </div>
                    }
                    {
                      this.props.order.relationships && this.props.order.relationships['line-items'].data.map((item, index) =>
                        <OrderDetailsRow
                          key={index}
                          index={index}
                          orderId={this.id}
                          confirmedProduct={this.props.confirmedProduct}
                          errors={this.props.errors}
                          selectedOutletId={this.props.selectedOutletId}
                          item={item}
                          orderLimitCategoryIds={orderLimitCategoryIds}
                          possibleHighlight={orderedSoFar >= orderLimit || reduceQtyBy > 0}
                          replacements={this.props.new.basket.replacements}
                          activeGameProductIds={this.props.order.attributes['active-game-product-ids']}
                          activeGameProducts={this.props.order.attributes['active-game-products']}
                          currentGameLevel={this.props.order.attributes['current-game-level']}
                          nextGameLevel={this.props.order.attributes['next-game-level']}
                        />)
                    }
                  </div>
                </Col>
              </Row>
            </Col>
            <Col lg={3} className="col-separator">
              <Row>
                <OrderSummary />
              </Row>
              {features.delivery_date &&
                <Row>
                  <OrderDeliveryDate />
                </Row>
              }
              <Row>
                <hr className="light" />
              </Row>
              <Row>
                {
                  this.props.order.attributes &&
                  <Col lg={12}>
                    <div className="total-header">
                      <div>Total (ex VAT) <strong className="total-money pull-right">€{(this.props.order.attributes['total-value-with-current-promotions'] || 0).toFixed(2)}</strong></div>
                    </div>
                  </Col>
                }
              </Row>
              <Row>
                {this.props.order.attributes &&
                <ConfirmOrderButton
                  arrow={false}
                  color="green"
                  className="checkout-button"
                  orderQty={this.props.order.attributes['total-number-of-items'] || 0}
                  disabled={!isRrfFormValid(this.props.form, { async: false })
                  || this.props.form.$form.pending || this.props.updateBasketFetching
                  || (this.props.order.relationships && !this.props.order.relationships['line-items'].data.length)
                  || (reduceQtyBy > 0)
                  || orderedSoFar >= orderLimit
                  || !this.props.selectedOutletId} />}
              </Row>
            </Col>
          </Row>
        </Form>
        {
          this.props.confirmation && <ThankYouPanel order={this.props.confirmation}
                                                    deliveryDate={deliveryDate}
                                                    onDone={this.handleDone}
                                                    onNewOrder={this.handleNewOrder}
                                                    onOrderAgain={this.handleOrderAgain} />
        }
        {isTobaccoModalOpen &&
          <ConfirmPopup onClose={this.handleTobaccoModalClose} confirmLabel="Order more">
            <p>Remember to add your tobacco products to your basket before confirming your order.</p>
          </ConfirmPopup>}
        {isZoneModalOpen &&
          <ConfirmPopup onClose={this.handleZoneModalClose} confirmLabel="Order more">
            <p>Remember to add your Zone (Oral tobacco) products to your basket before confirming your order.</p>
          </ConfirmPopup>}
        {isBluModalOpen &&
          <ConfirmPopup onClose={this.handleBluModalClose} confirmLabel="Order more">
            <p>Remember to add your Blu products to your basket before confirming your order.</p>
          </ConfirmPopup>}
      </Grid>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    order: state.orders.checkout,
    confirmation: state.orders.confirmation,
    confirmedProduct: state.orders.new.confirmedProduct,
    outlets: state.orders.orderMeta.outlets.data,
    errors: state.orders.orderMeta.errors,
    new: state.orders.new,
    orderLimit: state.orders.orderMeta.order_limit_details['order_limit'],
    orderLimitStartDate: state.orders.orderMeta.order_limit_details['start_date'],
    orderLimitEndDate: state.orders.orderMeta.order_limit_details['end_date'],
    orderedSoFar: state.orders.orderMeta.order_limit_details['ordered_so_far'],
    reduceQtyBy: state.orders.orderMeta.order_limit_details['reduce_qty_by'],
    orderLimitCategories: state.orders.orderMeta.order_limit_details['categories'],
    orderLimitCategoryIds: state.orders.orderMeta.order_limit_details['category_ids'] || [],
    fetched: state.orders.fetched,
    fetching: state.orders.fetching,
    updateBasketFetching: state.orders.update_basket_fetching,
    updateBasketFetched: state.orders.update_basket_fetched,
    form: state.deep.forms.order.confirm,
    features: state.features,
    selectedOutletId: state.deep.order.confirm.outlet_id,
    deliveryDate: state.deep.order.confirm.delivery_date,
    deliveryAddress: state.orders.new.deliveryAddress,
    contents: state.content.list,
  };
};

export default connect(mapStateToProps)(OrderConfirmation);



// WEBPACK FOOTER //
// ./src/components/new-order/confirm/index.jsx